import axios from 'axios';
import { toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
let setGlobalLoading = () => { };

export const injectLoadingHandler = (setLoadingFunc) => {
    setGlobalLoading = setLoadingFunc;
};

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'access-control-allow-orgin': '*'
    },
});

const apis = axios.create({
    baseURL: 'http://35.207.240.157:6090',
    headers: {
        'Content-Type': 'application/json',
    },
}); 

let activeRequests = 0;

const isForecastApi = (url = "") =>
    url.includes("/fetch/loadForecastModelmaster") ||
    url.includes("/fetch/WindgenForecastModelmaster") ||
    url.includes("/fetch/SolargenForecastModelmaster") ||
    url.includes("/fetch/DampriceForecastModelmaster");

api.interceptors.request.use((config) => {
    if (!isForecastApi(config.url)) {
        activeRequests++;
        setGlobalLoading(true);
    }
    return config;
}, (error) => {
    activeRequests--;
    if (activeRequests <= 0) setGlobalLoading(false);
    return Promise.reject(error);
});

api.interceptors.response.use(
    (response) => {
        if (!isForecastApi(response.config.url)) {
            activeRequests--;
            if (activeRequests <= 0) setGlobalLoading(false);
        }
        return response;
    },
    async function retryUntilSuccess(error) {
        const config = error.config;

        if (!config || (error.response && error.response.status === 404)) {
            if (!isForecastApi(config?.url)) {
                activeRequests--;
                if (activeRequests <= 0) setGlobalLoading(false);
            }
            toast.error("Requested data not found (404).");
            return Promise.reject(error);
        }

        await new Promise(resolve => setTimeout(resolve, 3000));
        return api(config);
    }
);

export const commitinternaldc = (data) => api.post('/post/commitinternaldc', data);
export const daintdcEditCommit = (data) => api.post('/post/daintdc_edit_commit', data);
export const commitInternalSch = (data) => api.post('/post/commitinternalsch', data);
export const commitDAEnt = (data) => api.post('/post/daentcommit', data);
export const commitISGSDC = (data) => api.post('/post/daisgsdc', data);
export const commitLoad = (data) => api.post('/post/commitload', data);

export const forecastApis = {
    "Load Forecast": (date) => api.get(`/fetch/forecastload?date=${date}`),
    "Price Forecast": (date) => api.get(`/fetch/iex_da_price?date=${date}`),
    "Solar Forecast": (date) => api.get(`/fetch/da_solargen_forecast?date=${date}`),
    "Wind Forecast": (date) => api.get(`/fetch/da_windgen_forecast?date=${date}`),
};

export const commitForecastApis = {
    "Load Forecast": (data) => api.post('/post/DayAheadHybridLoadForecast', data),
    "Price Forecast": (data) => api.post('/post/DayAheadHybridPriceForecast', data),
    "Solar Forecast": (data) => api.post('/post/DayAheadHybridSolarForecast', data),
    "Wind Forecast": (data) => api.post('/post/DayAheadHybridWindForecast', data),
};

export const forecastRangeApis = {
    "Load Forecast": (fromDate, toDate) =>
        api.get(`/fetch/duration_forecastload?from_date=${fromDate}&to_date=${toDate}`),

    "Price Forecast": (fromDate, toDate) =>
        api.get(`/fetch/duration_forecastprice?from_date=${fromDate}&to_date=${toDate}`),

    "Solar Forecast": (fromDate, toDate) =>
        api.get(`/fetch/duration_solargen_forecast?from_date=${fromDate}&to_date=${toDate}`),

    "Wind Forecast": (fromDate, toDate) =>
        api.get(`/fetch/duration_windgen_forecast?from_date=${fromDate}&to_date=${toDate}`),
};

export const loginUser = (emailOrPhone, password) => {
    const payload = { password };

    if (/^\d+$/.test(emailOrPhone)) {
        payload.id_type = "phone_no";
        payload.phone_no = emailOrPhone;
    } else {
        payload.id_type = "email_id";
        payload.email_id = emailOrPhone;
    }

    return api.post('/auth/autheticate_user', payload);
};

export const resetPassword = (emailOrPhone) => {
    const payload = {};

    if (/^\d+$/.test(emailOrPhone)) {
        payload.id_type = "phone_no";
        payload.phone_no = emailOrPhone;
    } else {
        payload.id_type = "email_id";
        payload.email_id = emailOrPhone;
    }

    return api.post('/auth/reset_password_link', payload);
};

export const registerUser = ({ user_name, first_name, last_name, email_id, organization_name, password, phone_no }) => {
    const payload = {
        user_name,
        first_name,
        last_name,
        email_id,
        organization_name,
        password,
        phone_no
    };

    return api.post('/auth/registeruser', payload);
};

export const fetchUnitCostMaster = () => api.get("/fetch/unit_cost_master");
export const fetchUnitMaster = () => api.get("/fetch/unit_master");
export const fetchPlantTypes = () => api.get("/fetch/planttype");
export const fetchFuelTypes = () => api.get("/fetch/fueltype");
export const commitUnitMaster = (data) => api.post('/post/unitmaster', data);
export const commitCostMaster = (data) => api.post('/post/unit_cost_master', data);
export const fetchLocalPlantUnit = () => api.get("/fetch/plant_unit_master");
export const fetchisgsEnt = (date) => api.get(`/fetch/isgs_ent?date=${date}`);
export const fetchippsEnt = (date) => api.get(`/fetch/ipps_ent?date=${date}`);
export const fetchDamClearingPrice = (date) => api.get(`/fetch/dam_clearing_price?date=${date}`);
export const fetchRtmClearingPrice = (date) => api.get(`/fetch/rtm_clearing_price?date=${date}`);
export const fetchGdamClearingPrice = (date) => api.get(`/fetch/gdam_clearing_price?date=${date}`);
export const fetchIsgsCurrentSchedule = (date) => api.get(`/fetch/isgs_current_schedule?date=${date}`);
export const fetchDayAheadEntitlement = (date) => api.get(`/fetch/da_committed_entitlement?date=${date}`);

export const fetchDaEntSummary = (date, selected_model_demand_forecast, selected_model_price_forecast, selected_model_solar_gen, selected_model_wind_gen) =>
    api.get(`/fetch/da_ent_summary?date=${date}&selected_model_demand_forecast=${selected_model_demand_forecast}&selected_model_price_forecast=${selected_model_price_forecast}&selected_model_solar_gen=${selected_model_solar_gen}&selected_model_wind_gen=${selected_model_wind_gen}`);

export const fetchDaMinSchedule = (date, selected_model_demand_forecast, selected_model_price_forecast, selected_model_solar_gen, selected_model_wind_gen) =>
    api.get(`/fetch/da_min_schedule?date=${date}&selected_model_demand_forecast=${selected_model_demand_forecast}&selected_model_price_forecast=${selected_model_price_forecast}&selected_model_solar_gen=${selected_model_solar_gen}&selected_model_wind_gen=${selected_model_wind_gen}`);

export const fetchPositionMap = (date, selected_model_solar_gen, selected_model_wind_gen, selected_model_demand_forecast) =>
    api.get(`/fetch/da_position_map?date=${date}&selected_model_solar_gen=${selected_model_solar_gen}&selected_model_wind_gen=${selected_model_wind_gen}&selected_model_demand_forecast=${selected_model_demand_forecast}`);

export const fetchMinSchPositionMap = (date, selected_model_solar_gen, selected_model_wind_gen, selected_model_demand_forecast) =>
    api.get(`/fetch/da_residual_demand?for_date=${date}&selected_model_solar_gen=${selected_model_solar_gen}&selected_model_wind_gen=${selected_model_wind_gen}&selected_model_demand_forecast=${selected_model_demand_forecast}`);

export const fetchDaMod = (date, selected_model_solar_gen, selected_model_wind_gen, selected_model_demand_forecast) =>
    api.get(`/fetch/da_mod?for_date=${date}&selected_model_solar_gen=${selected_model_solar_gen}&selected_model_wind_gen=${selected_model_wind_gen}&selected_model_demand_forecast=${selected_model_demand_forecast}`);

export const fetchDaReplacementOpp = (date, selected_model_solar_gen, selected_model_wind_gen, selected_model_demand_forecast, selected_model_price_forecast, transaction_cost, trading_margin) =>
    api.get(`/fetch/da_replacement_opportunity?for_date=${date}&selected_model_solar_gen=${selected_model_solar_gen}&selected_model_wind_gen=${selected_model_wind_gen}&selected_model_demand_forecast=${selected_model_demand_forecast}&selected_model_price_forecast=${selected_model_price_forecast}&transaction_cost=${transaction_cost}&trading_margin=${trading_margin}`);

export const fetchDaSalesTradeMaster = (date, selected_model_solar_gen, selected_model_wind_gen, selected_model_demand_forecast, selected_model_price_forecast, transaction_cost, trading_margin_sale) =>
    api.get(`/fetch/da_sale_trade_master?for_date=${date}&selected_model_solar_gen=${selected_model_solar_gen}&selected_model_wind_gen=${selected_model_wind_gen}&selected_model_demand_forecast=${selected_model_demand_forecast}&selected_model_price_forecast=${selected_model_price_forecast}&transaction_cost=${transaction_cost}&trading_margin_sale=${trading_margin_sale}`);

export const commitDaReplacementTrade = (data) => api.post('/post/da_replacement_trade', data);

export const mrRateApis = {
    "Load Forecast": (date, mr_rate, model) =>
        api.get(`/fetch/current_demand_forecast?for_date=${date}&mr_rate=${mr_rate}&selected_model_demand_forecast=${model}`),

    "Wind Forecast": (date, mr_rate, model) =>
        api.get(`/fetch/current_windgen_forecast?for_date=${date}`),
    // api.get(`/fetch/current_windgen_forecast?for_date=${date}&mr_rate=${mr_rate}&selected_model_wind_gen=${model}`),

    "Solar Forecast": (date, mr_rate, model) =>
        api.get(`/fetch/current_solargen_forecast?for_date=${date}&mr_rate=${mr_rate}&selected_model_solar_gen=${model}`),

    "Price Forecast": (date, mr_rate, model) =>
        api.get(`/fetch/current_pricegen_forecast?for_date=${date}&mr_rate=${mr_rate}&selected_model_price_forecast=${model}`)
};

export const dashboardApis = {
    "Load Forecast": (date, mr_rate, model) =>
        api.get(`/fetch/rt_demand_forecast?for_date=${date}&mr_rate=${mr_rate}&selected_model_demand_forecast=${model}`),

    "Wind Forecast": (date, mr_rate, model) =>
        api.get(`/fetch/rt_windgen_forecast?for_date=${date}&mr_rate=${mr_rate}&selected_model_wind_gen=${model}`),

    "Solar Forecast": (date, mr_rate, model) =>
        api.get(`/fetch/rt_solargen_forecast?for_date=${date}&mr_rate=${mr_rate}&selected_model_solar_gen=${model}`),
};

export const fetchCurrentScheduleMaster = (date) => api.get(`/fetch/current_sch_master?for_date=${date}`);
export const fetchCurrentCapacityOverMin = (date, selected_model_solar_gen, selected_model_wind_gen) => api.get(`/fetch/current_capacity_over_min?for_date=${date}&selected_model_wind_gen=${selected_model_wind_gen}&selected_model_solar_gen=${selected_model_solar_gen}`);
export const fetchCurrentRampCapacityMaster = (date, selected_model_solar_gen, selected_model_wind_gen) => api.get(`/fetch/current_ramp_capacity_master?for_date=${date}&selected_model_wind_gen=${selected_model_wind_gen}&selected_model_solar_gen=${selected_model_solar_gen}`);
export const fetchDashboardTable = () => api.get(`/fetch/rt_forecast_table`);
export const fetchLoadModel = () => api.get(`/fetch/loadForecastModelmaster`);
export const fetchWindModel = () => api.get(`/fetch/WindgenForecastModelmaster`);
export const fetchSolarModel = () => api.get(`/fetch/SolargenForecastModelmaster`);
export const fetchPriceModel = () => api.get(`/fetch/DampriceForecastModelmaster`);

export const postMRRates = (data) => api.post('/post/mr_rate', data);
export const fetchRtWindForecast = (date) => api.get(`/fetch/rt_windgen_forecast_report?for_date=${date}`);
export const deleteEntitlement = (date) => apis.get(`/delete/da_ent_sch?for_date=${date}`);
export const fetchMcpWtDavg = (fromDate, toDate) => api.get(`/fetch/mcp_wtdavg?from_date=${fromDate}&to_date=${toDate}`);
export const fetchMcpDamg = (fromDate, toDate) => api.get(`/fetch/mcp_damgdamrtm?from_date=${fromDate}&to_date=${toDate}`);
export const fetchStationFeeder = () => api.get(`/fetch/station_feeder_dd`);

export const fetchStationFeederList = (discom, substation) => api.get(`/fetch/station_feeder_list?discom=${discom}&substation=${substation}`);
export const commitFeeder = (data) => api.post('/post/feeder_load', data);
export const fetchStationFeederLoad = (date, discom, substation) => api.get(`/fetch/user_feeder_load?date=${date}&discom=${discom}&substation=${substation}`);

export default api;

//http://35.207.240.157:6090/delete/da_ent_sch?for_date=2025-08-07